"use client";

import { cn } from "@/lib/cn";

export function Tooltip({
  content,
  children,
  className,
  side = "top",
  align = "center",
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}) {
  const verticalSide = side === "top" || side === "bottom";

  return (
    <span className={cn("group relative inline-flex", className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          "pointer-events-none invisible absolute z-50 w-max max-w-64 rounded-lg bg-dark px-3 py-2 text-left text-xs leading-5 font-medium text-on-primary opacity-0 shadow-xl transition group-hover:visible group-hover:opacity-100 group-has-focus-visible:visible group-has-focus-visible:opacity-100",
          side === "top" && "bottom-[calc(100%+0.5rem)]",
          side === "right" && "left-[calc(100%+0.5rem)]",
          side === "bottom" && "top-[calc(100%+0.5rem)]",
          side === "left" && "right-[calc(100%+0.5rem)]",
          verticalSide && align === "start" && "left-0",
          verticalSide && align === "center" && "left-1/2 -translate-x-1/2",
          verticalSide && align === "end" && "right-0",
          !verticalSide && align === "start" && "top-0",
          !verticalSide && align === "center" && "top-1/2 -translate-y-1/2",
          !verticalSide && align === "end" && "bottom-0",
        )}
      >
        {content}
      </span>
    </span>
  );
}
